import { render, staticRenderFns } from "./InventoryArchive.vue?vue&type=template&id=a3bb1c54&scoped=true&"
import script from "./InventoryArchive.vue?vue&type=script&lang=js&"
export * from "./InventoryArchive.vue?vue&type=script&lang=js&"
import style0 from "./InventoryArchive.vue?vue&type=style&index=0&id=a3bb1c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bb1c54",
  null
  
)

export default component.exports